// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2-drZ","header":"Messages_header__12lhz"};